<div class="content-compact"
[ngClass]="AppSettings.IsRunningInSingularity ? 'content-compact-sso' : ''">
    <div class="recconsole-header"
    [ngClass]="AppSettings.IsRunningInSingularity ? 'recconsole-header-sso' : '' ">
        <div class="consoleHeader" consoleHeaderOffset
        [ngClass]="AppSettings.IsRunningInSingularity ? 'consoleHeader-sso' : ''">
            <div class="row flex-nowrap">
                <div class="col-auto d-flex header_section" *ngIf="Propertylst && Propertylst.length > 1">
                    <div ngbDropdown class="w-auto dropdown-noarrow align-self-center">
                        <button class="btn btn-link firstFilter" ngbDropdownToggle><i class="ksv-icon-building" title="{{'TITLE.TITLE_SELECT_PROPERTIES' | translate}}"></i></button>
                        <div class="dropdown-menu scrollable-dropdown-menu" ngbDropdownMenu>
                            <button class="dropdown-item" *ngFor="let row of Propertylst" [ngClass]="{'active': RequestModel.PropertyId == row.PropertyId}" (click)="OnPropertyChange(row)">{{row.PropertyName}}</button>
                        </div>
                    </div>
                </div>
                <div class="col-auto topFilters header_section headerlink-2line">
                    <a *ngFor="let row of PropStatModel" (click)="OnTopFilter(row.Id)" [ngClass]="{'active': FilterModel.StatusCode == row.Id}">
                        <div class="topFilter_Label text-center" translate>{{row.Label}} </div>
                        <div class="small text-center">({{row.Value}})</div>
                    </a>
                </div>
                <!--<div class="col-auto d-flex align-items-center ml-5">
        <div class="input-group align-self-center">
            <div class="input-group-prepend">
                <span class="input-group-text pointer" (click)="jobFilter.onOpen(FilterModel)" [ngClass]="FilterModel.HasFilters ? 'highlight_Color':''"><i class="fas fa-filter" title="{{'TITLE.TITLE_FILTERS' | translate}}"></i></span>
            </div>
            <input #keyword class="form-control" type="text" placeholder="{{'PH.PH_SEARCH' | translate}}" (keyup)="SetData()" [(ngModel)]="FilterModel.Keyword">
            <div class="input-group-append">
                <button class="btn btn-secondary" type="button" (click)="onClearFilter()" title="{{'TITLE.TITLE_CLEAR_FILTER' | translate}}"><i class="fas fa-eraser"></i></button>
            </div>
        </div>
    </div>-->
                <div class="col-auto d-flex align-items-center header_section">
                    <div class="searchFilterResult">
                        <input type="text" [(ngModel)]="FilterModel.Keyword" placeholder="{{'PH.PH_SEARCH' | translate}}" (keyup)="SetData()" class="form-control searchFilter_Text" />
                    </div>
                </div>

                <div class="col-auto d-flex header_section align-items-center px-4" [ngClass]="FilterModel.HasFilters ? 'backHightlight':''">
                    <div class="pointer" (click)="jobFilter.onOpen(FilterModel)" title="{{'TITLE.TITLE_FILTERS' | translate}}"><i class="fas fa-filter"></i></div>
                    <div class="ml-4 pointer" (click)="onClearFilter()" *ngIf="FilterModel.HasFilters"><i class="fas fa-times fa-lg mr-2"></i>{{'TITLE.TITLE_CLEAR_FILTER' | translate}}</div>
                </div>
                
                <div class="col d-flex justify-content-end">
                    <div class="header_section align-items-center px-3">
                        <div class="pointer" (click)="ExportToExcel()" title="{{'TITLE.TITLE_EXPORT_EXCEL' | translate}}"><i class="far fa-lg fa-file-excel"></i></div>
                    </div>
                    <div class="header_section align-items-center px-3">
                        <div class="pointer" (click)="OpenKeyModal()" title="{{'TITLE.TITLE_LEGENDS' | translate}}"><i class="fa fa-lg fa-key fa-fw"></i></div>
                    </div>
                    <div class="header_section align-items-center px-3">
                        <div class="pointer" (click)="Refresh()" title="{{'TITLE.TITLE_REFRESH' | translate}}"><i class="fa fa-lg fa-sync-alt"></i></div>
                    </div>
                </div>
            </div>
            <div class="row pagerow justify-content-between flex-nowrap">
                <div class="col-auto d-flex align-items-center p-0">
                    <div ngbDropdown>
                        <button class="btn btn-link btn-nonlink p-0 mr-2" id="selSort" ngbDropdownToggle title="{{'BTN.BTN_SORT_BY' | translate}}"><i class="mr-2 fas fa-sort"></i>{{SortByText | translate}}</button>
                        <div ngbDropdownMenu aria-labelledby="selSort">
                            <button *ngFor="let row of SortParams" class="dropdown-item pointer" [ngClass]="{'active': row.Id == FilterModel.OrderBy}" (click)="OnSort(row)" translate>{{row.Name}}</button>
                        </div>
                    </div>
                    <div class="ml-2" *ngIf="Model && Model.TotalRecords > 0">
                        <ngb-pagination [collectionSize]="Model.TotalRecords" [pageSize]="FilterModel.PageSize" [(page)]="FilterModel.PageNumber" [boundaryLinks]="true" (pageChange)="OnPageChange()"></ngb-pagination>
                    </div>
                    <div class="mx-4" *ngIf="Model"><span translate>LBL.TOTAL_RECORDS</span>: <B>{{Model.TotalRecords}}</B></div>
                    <select #months [hidden]="FilterModel.StatusCode == 'Y' || FilterModel.StatusCode == 'D'" class="form-control form-control-sm col p-0" (change)="OnMonthChange(months.value)">
                        <option *ngFor="let month of ['1','2','3','4','5','6','7','8','9','10','11','12','All']" [value]='month'>{{month}}</option>
                    </select>
                    <span class="ml-1" [hidden]="FilterModel.StatusCode == 'Y' || FilterModel.StatusCode == 'D'" translate>LBL.MONTHS</span>
                </div>

            </div>
        </div>
    </div>

    <div class="row recconsole-body">
        <div class="col">
            <div *ngIf="Model && Model.TotalRecords == 0" class="noRecords"><span translate>LBL.NO_RECORD_FOUND</span></div>
            <sk-wave [isRunning]="IsSubmitting"></sk-wave>
            <div class="recConsole" *ngIf="IsSubmitting == false && Model && Model.TotalRecords > 0">
                <div class="grdGrid">
                    <div class="grdRow row pointer no-gutters" *ngFor="let row of Model.Result" (click)="ShowJobDetail(row)" [ngClass]="{'selected': Selected && row.RecurrenceId == Selected.RecurrenceId }">
                        <div class="col-auto grdCol align-items-center">
                            <div class="d-flex">
                                <div title="{{row.Status}}" class="statusIcon-Standard status-{{row.Status}} mr-2" [ngClass]="{'border-0': (row.StatusCode == 'D') }"></div>
                                <div translate>{{row.StatusName}}</div>
                            </div>
                            <div class="ellipsis text-muted small ml-4" title="{{('TITLE.TITLE_FREQUENCY' | translate) + ' - '+ row._RecurrenceFrequency}}">{{row._RecurrencePattern}}</div>
                        </div>
                        <div class="col-auto grdCol" title="{{'TITLE.TITLE_JOB_DESCR' | translate}}">{{row.CallDescription}}&nbsp;</div>
                        <div class="col-auto grdCol">
                            <div class="ellipsis" title="{{('TITLE.TITLE_LOCATION' | translate) +' - '+row.Location}}"><i class="fas fa-map-marker-alt"></i> {{row.Location}}</div>
                            <div class="text-muted small" title="{{'TITLE.TITLE_ROOM_STATUS' | translate}}">{{row._RoomStatus}}</div>
                        </div>
                        <div class="col-auto grdCol">
                            <div class="ellipsis" title="{{('TITLE.TITLE_DEPARTMENTS' | translate) +' - '+ row.Department}}">{{row.Department}}</div>
                            <div class="text-muted small" *ngIf="masterService.LoggedInUserData.Properties.length > 1" title="{{'TITLE.TITLE_PROPERTY' | translate}} - {{row.PropertyName}}"><i class="fas fa-building"></i> {{row.PropertyCode}}</div>
                        </div>
                        <div class="col-auto grdCol">
                            <div class="ellipsis" [ngSwitch]="row.StatusCode">
                                <span *ngSwitchCase="'Y'" [hidden]="!row.ReopenDateTime"><span translate>LBL.NEXT_RUN_ON</span> {{row.ReopenDateTime | amDateFormat: DateFormat}}</span>
                                <span *ngSwitchCase="'N'" [hidden]="!row.EndDateTime"><span translate>LBL.EXPIRED_ON</span> {{row.EndDateTime | amDateFormat: DateFormat}}</span>
                                <span *ngSwitchCase="'D'" [hidden]="!row.LastUpdateTime"><span translate>LBL.DELETED_ON</span> {{row.LastUpdateTime | amDateFormat: DateFormat}}</span>
                            </div>
                            <div class="text-muted small" title="{{'TITLE.TITLE_PATTERN' | translate}}">{{row._EndPattern}}</div>
                        </div>
                        <div class="col-md grdCol ellipsis linebreak" title="{{row.Comments}}" data-html="true">{{row.Comments}}</div>
                        <div class="col-auto grdCol pr-4 d-flex align-items-center">
                            <i title="{{'ICON_DEF.ICON_DEF_WORKORDER' | translate}}" class="kmt-icons text-danger kmt-icon-construction" *ngIf="row.ComplainType == 4"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #recurrenceKey let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h6 class="modal-title" translate>TITLE.TITLE_KEY</h6>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body container-fluid">
        <div class="row">
            <div class="col-6 pr-0 d-flex">
                <div class="col-1 px-0"><i class="far fa-file-excel"></i></div>
                <div class="pl-0" translate>
                    ICON_DEF.ICON_DEF_EXCEL_EXPORT
                </div>
            </div>
            <div class="col-6 d-flex">
                <div class="col-1 px-0"><i class="fas fa-sync-alt"></i></div>
                <div class="pl-0" translate>
                    ICON_DEF.ICON_DEF_REFRESH
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 pr-0 d-flex">
                <div class="col-1 px-0 text-center">
                    <div class="statusIcon-Standard status-ACTIVE" title=""></div>
                </div>
                <div class="pl-0" translate>
                    ICON_DEF.ICON_DEF_ACTIVE_RECURRENCE
                </div>
            </div>
            <div class="col-6 d-flex">
                <div class="col-1 px-0 text-center">
                    <div class="statusIcon-Standard status-EXPIRED" title=""></div>
                </div>
                <div class="pl-0" translate>
                    ICON_DEF.ICON_DEF_EXPIRED_RECURRENCE
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 pr-0 d-flex">
                <div class="col-1 px-0 text-center">
                    <div class="statusIcon-Standard status-DELETED border-dark" title=""></div>
                </div>
                <div class="pl-0" translate>
                    ICON_DEF.ICON_DEF_DELETED_RECURRENCE
                </div>
            </div>
            <div class="col-6 d-flex">
                <div class="col-1 px-0"><i class="fas fa-map-marker-alt"></i></div>
                <div class="pl-0" translate>
                    ICON_DEF.ICON_DEF_LOCATION
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 pr-0 d-flex">
                <div class="col-1 px-0"><i class="fas fa-sort"></i></div>
                <div class="pl-0" translate>
                    ICON_DEF.ICON_DEF_SORT
                </div>
            </div>
            <div class="col-6 d-flex">
                <div class="col-1 px-0"><i class="fas fa-bell"></i></div>
                <div class="pl-3" translate>
                    ICON_DEF.ICON_DEF_NOTIFICATION
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 d-flex px-0">
                <div class="statusIcon col-1 connectionIcon"><i class="ksv-icon-connection-off statusIcon-Error"></i></div>
                <div class="pl-3" translate>
                    ICON_DEF.ICON_DEF_CONNECTION_FAIL
                </div>
            </div>
            <div class="col-6 pl-0 d-flex">
                <div class="statusIcon col-1 connectionIcon"><i class="ksv-icon-connection-on statusIcon-Sucess"></i></div>
                <div class="pl-3" translate>
                    ICON_DEF.ICON_DEF_CONNECTION_SUCCESS
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6 d-flex px-0">
                <div class="col-1 usr-info"><i class="fas fa-info-circle"></i></div>
                <div class="pl-3" translate>
                    ICON_DEF.ICON_DEF_USR_INFO
                </div>
            </div>
            <div class="col-6 pl-0 d-flex">
               &nbsp;
            </div>
        </div>
    </div>
    <div class="modal-footer ">
        <button type="button" class="btn btn-primary mr-3" (click)="c('close')" translate>BTN.BTN_OK</button>
    </div>

</ng-template>


<!--<RecurrenceFilter #recurrenceFilter (ApplyFilter)="SetData()"></RecurrenceFilter>-->
<JobFilter #jobFilter [EnabledFilters]="RecurrenceFilters" (ApplyFilter)="SetData()"></JobFilter>
<RecurrencePopover #recurrencePopover [Selected]="Selected" (Deleted)="OnDelete()" (RecurrenceChanged)="GetData()"></RecurrencePopover>
